export default {
  login: "angelabauer",
  id: 8798027,
  node_id: "MDQ6VXNlcjg3OTgwMjc=",
  avatar_url: "https://avatars.githubusercontent.com/u/8798027?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/angelabauer",
  html_url: "https://github.com/angelabauer",
  followers_url: "https://api.github.com/users/angelabauer/followers",
  following_url:
    "https://api.github.com/users/angelabauer/following{/other_user}",
  gists_url: "https://api.github.com/users/angelabauer/gists{/gist_id}",
  starred_url:
    "https://api.github.com/users/angelabauer/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/angelabauer/subscriptions",
  organizations_url: "https://api.github.com/users/angelabauer/orgs",
  repos_url: "https://api.github.com/users/angelabauer/repos",
  events_url: "https://api.github.com/users/angelabauer/events{/privacy}",
  received_events_url:
    "https://api.github.com/users/angelabauer/received_events",
  type: "User",
  site_admin: false,
  name: "Angela Yu",
  company: "@londonappbrewery ",
  blog: "https://www.appbrewery.co",
  location: "London, UK",
  email: null,
  hireable: null,
  bio: "Medical doctor. iOS Developer. Founder of the App Brewery. Teaching 500,000+ students how to code.",
  twitter_username: null,
  public_repos: 30,
  public_gists: 24,
  followers: 6590,
  following: 0,
  created_at: "2014-09-16T21:03:28Z",
  updated_at: "2021-04-20T15:23:52Z",
};
